import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

let myself: DynamicLayoutTileComponent = null;

@Component({
  selector: 'app-dynamic-layout-tile',
  templateUrl: './dynamic-layout-tile.component.html',
  styleUrls: ['./dynamic-layout-tile.component.css']
})
export class DynamicLayoutTileComponent implements OnInit {

  _tile: any = null;
  _data: any = null;
  values: any;
  
  dynamicLayoutDataSource: (dynamicLayoutId: number) => Observable<any>;

  constructor() {
    myself = this;
  }

  ngOnInit() {
  }

  @Input()
  set data(tileData: any) {
    this._data = tileData;
    let vals = null;
    
    if (tileData != null && tileData.Values != null) {
      vals = {};
      for (var i = 0; i < tileData.Values.length; i++) {
        vals[tileData.Values[i].ColumnId] = tileData.Values[i].Value;
      }
    }
    this.values = vals;
  }
  get data(): any {
    return this._data;
  }

  @Input()
  set tile(tile: any) {
    this._tile = tile;
    if (tile != null && tile) {
      tile.refreshGrid = function () {
        myself.refreshGrids(); 
      };
    }
  }
  get tile(): any {
    return this._tile;
  }


  @Input()
  set dataSource(ds: (dynamicLayoutId: number) => Observable<any>) {
    this.dynamicLayoutDataSource = ds;
  }

  refreshGrids() {
    if (this._tile != null && typeof (this._tile.updateTheGrid) === "function") {
      this._tile.updateTheGrid();
    }
  }
}
